import React, { useEffect } from "react";
import Button from "./Button";
import { Link } from "react-router-dom";

import AOS from "aos";
import "aos/dist/aos.css";

const Contactcomp = () => {
  useEffect(() => {
    AOS.init({ once: true });
  }, []);

  const supportImage = "./assets/bmt/Clinician_Image_1.jpg";

  return (
    <section
      data-aos="fade-up"
      data-aos-duration="700"
      className="relative px-[25px] sm:px-16 py-20 flex flex-col lg:flex-row items-center gap-16 overflow-hidden"
    >
      {/* --- CURVED TOP SECTION (Optional, subtle premium touch) --- */}
      <div className="absolute top-0 left-0 w-full h-16 rounded-b-[60%] bg-gradient-to-b from-white to-transparent pointer-events-none"></div>

      {/* LEFT – IMAGE WITH MASK, GLOW, AND ICONS */}
      <div
        data-aos="fade-right"
        className="relative w-full lg:w-1/2 flex justify-center"
      >
        {/* Soft Glow */}
        <div className="absolute -bottom-12 -left-8 w-60 h-60 bg-primary_red/10 blur-3xl rounded-full"></div>

        {/* Image Mask + Premium Crop */}
        <div className="relative w-full max-w-[550px] rounded-[32px] overflow-hidden shadow-2xl">
          <img
            src={supportImage}
            alt="Support"
            className="w-full h-full object-cover scale-105 transition-all duration-[800ms] hover:scale-110"
            style={{
              maskImage:
                "linear-gradient(to bottom, black 80%, transparent 100%)",
            }}
          />

          {/* Floating Micro Icons */}
          <div className="absolute top-5 right-5 bg-white/80 backdrop-blur-md w-12 h-12 rounded-full shadow-md flex items-center justify-center animate-pulse">
            <span className="text-primary_red text-xl">❤️</span>
          </div>

          <div className="absolute bottom-5 left-5 bg-white/80 backdrop-blur-md w-12 h-12 rounded-full shadow-md flex items-center justify-center animate-[ping_2s_linear_infinite]">
            <span className="text-primary_red text-lg">🤝</span>
          </div>
        </div>
      </div>

      {/* RIGHT – TEXT + GLASS CTA CARD */}
      <div
        data-aos="fade-left"
        className="relative w-full lg:w-1/2 flex flex-col justify-center"
      >
        {/* Accent Bar */}
        <div className="w-20 h-1 bg-primary_red mb-6 rounded-full"></div>

        {/* Magazine-style Heading */}
        <h2 className="text-[34px] lg:text-[50px] font-semibold leading-[1.15] text-gray-900 tracking-tight">
          You’re Never Alone—
          <span className="text-primary_red">We’re Here for You</span>
        </h2>

        {/* Supporting text */}
        <p className="text-[18px] text-gray-700 mt-6 leading-relaxed max-w-[90%]">
          Whether you or someone you love is living with Sickle Cell Disorder,
          our dedicated team is ready to guide, support, and connect you with
          care—every step of the way.
        </p>

        {/* GLASS CTA CARD */}
        <div className="mt-10 p-7 rounded-2xl bg-white/60 backdrop-blur-lg border border-white/40 shadow-xl max-w-sm transition hover:shadow-2xl">
          <p className="text-[17px] text-gray-800">
            Speak with a support specialist today.
          </p>

          <Link to="/contact">
            <Button
              classes="px-10 py-3 bg-primary_red font-Lexend font-semibold rounded-md text-[16px] text-white hover:bg-primary_red/90 mt-5 transition-all shadow-lg w-full"
              text="Contact Us"
            />
          </Link>
        </div>
      </div>

      {/* Floating Accent Shapes */}
      <div className="absolute bottom-10 right-10 w-32 h-32 rounded-3xl bg-primary_red/5 blur-xl"></div>
    </section>
  );
};

export default Contactcomp;
